



































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import VueDatepicker from 'vuejs-datepicker';
import { ja } from 'vuejs-datepicker/dist/locale';
import moment, { Moment } from 'moment';
import { uuid } from 'vue-uuid';

@Component({
  components: {
    VueDatepicker,
  },
})
export default class DatePicker extends Vue {
  private language: object = ja;
  private id: string = '';
  private formatted: string = '';
  private tooltip: string = '';
  @Prop()
  private value!: string | Date | null;
  @Prop({default: true})
  private typeable!: boolean;
  @Prop({default: 'YYYY/MM/DD'})
  private format!: string;
  @Prop({default: undefined})
  private disabledDates!: {
    to: Date | null,
    from: Date | null,
    days: number[],
  };
  @Prop({default: null})
  private appendClass!: string | JSON | null;
  @Prop({default: false})
  private disabled!: boolean;

  private alert: boolean = false;

  public created(): void {
    this.id = uuid.v1();
    moment.locale('ja');
    this.apply();
  }

  private style(): any {
    const style: any = {
      disabled: this.disabled,
      alert: this.alert,
    };
    if (!this.appendClass) {
      return style;
    }
    if (typeof this.appendClass === 'string') {
      style[this.appendClass] = true;
      return style;
    }
    return Object.assign(style, this.appendClass);
  }

  @Watch('value')
  private apply(): void {
    this.formatted = '';
    const date = this.getValue();

    if (!date) {
      return;
    }

    if (date.isValid()) {
      this.formatted = date.format(this.format);
      return;
    }

    this.formatted = '' + this.value;
    this.alert = true;
    this.tooltip = '不正な日付です';
  }

  private getValue(): Moment | null {
    if (!this.value) {
      return null;
    }
    if (typeof this.value === 'string') {
      return moment(this.value, 'YYYY-MM-DD', true);
    }

    return moment(this.value);
  }

  private textualFormat(event: Event): void {
    const date = this.getValue();
    if (!date) {
      return;
    }

    if (!date.isValid()) {
      this.formatted = '' + this.value;
      this.inValid(event);
      return;
    }

    this.formatted = date.format('YYYYMMDD');
    this.$nextTick(() => {
      const target = event.target as HTMLInputElement;
      target.select();
    });
  }

  @Emit('input')
  private update(event: Event): string | Date | null {
    this.alert = false;
    this.tooltip = '';

    const target = event.target as HTMLInputElement;
    if (!target.value) {
      return null;
    }
    const targetValue: string = target.value;

    if (targetValue.match(/^[12][0]\d{6}/g)) {
      const year = targetValue.slice(0, 4);
      const month = targetValue.slice(4, 6);
      const day = targetValue.slice(6, 8);
      const date = moment(year + '-' + month + '-' + day);

      if (date.isValid()) {
        if (this.typeable) {
          return date.toDate();
        }
        return date.format('YYYY-MM-DD');
      }
    }

    // YYYY-MM-DD or YYYY/MM/DD だった場合
    if (targetValue.match(/^[12][0]\d{2}-\d{2}-\d{2}/g) || targetValue.match(/^[12][0]\d{2}\/\d{2}\/\d{2}/g)) {
      const year = targetValue.slice(0, 4);
      const month = targetValue.slice(5, 7);
      const day = targetValue.slice(8, 10);
      const date = moment(year + '-' + month + '-' + day);

      if (date.isValid()) {
        if (this.typeable) {
          return date.toDate();
        }
        return date.format('YYYY-MM-DD');
      }
    }
    // MM/DD だった場合
    if (targetValue.match(/^\d{1,2}\/\d{1,2}/g)) {
      const year = moment().year();
      const month = Number(targetValue.split('/')[0]);
      const day = targetValue.split('/')[1];
      const date = moment([year, month - 1, day]);

      if (date.isValid()) {
        if (this.typeable) {
          return date.toDate();
        }
        return date.format('YYYY-MM-DD');
      }
    }

    this.inValid(event);
    this.changed(event);
    return targetValue;
  }

  private click(): void {
    this.$modal.show(this.id);
  }

  private inValid(event: Event): void {
    this.alert = true;
    this.tooltip = '不正な日付です';
    this.$nextTick(() => {
      const target = event.target as HTMLInputElement;
      target.select();
    });
  }

  @Emit('input')
  private selected(date: Date): string | Date | null {
    this.$modal.hide(this.id);

    if (!date) {
      return null;
    }

    if (this.typeable) {
      return moment(date).toDate();
    }

    return moment(date).format('YYYY-MM-DD');
  }

  @Emit('changed')
  private changed(event: Event): Event {
    return event;
  }

  @Emit('keydown-enter-prevent')
  private keydown(event: Event): Event {
    return event;
  }
 }
